<template>
    <header-component :bookingHeaderColor="'bookingapp'" />

    <div class="bgimg">
        <div class="topleft">
        </div>
        <div class="middle">
            <h1>COMING SOON</h1>
            <hr>
        </div>
    </div>
</template>

<script>
import HeaderComponent from "@/components/common/HeaderComponent/index.vue";
export default {
    components: { HeaderComponent },
}
</script>
<style>
.bgimg {
    background-color: rgb(85, 153, 209);
    height: 100%;
    background-position: center;
    background-size: cover;
    position: relative;
    color: white;
    font-family: arial;
    font-size: 25px;
}

.topleft {
    position: absolute;
    top: 0;
    left: 16px;
}

.bottomleft {
    position: absolute;
    bottom: 0;
    left: 16px;
}

.middle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

hr {
    margin: auto;
    width: 100%;
}
</style>

